import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import validator from "validator"
import HttpClient from "../../helpers/HttpClient"
import Contact, { ContactDto } from "../models/contact"

export const ORGANIZATION_TYPE = "organizations"
class ContactService {
    httpClient: HttpClient<Contact, ContactDto> = new HttpClient<Contact, ContactDto>(Contact)

    async Get(id: string) {
        return this.httpClient.get(`/contacts/${id}`)
    }

    async GetPrimaryContactFromCompany(id: string) {
        const contactRes = await this.Get(id)
        if (contactRes instanceof Contact) {
            const contactType = contactRes.getType()
            if (contactType === ORGANIZATION_TYPE) {
                const primaryContactId = contactRes.getPrimaryContactId()
                const primaryContactRes = await this.Get(primaryContactId)
                return primaryContactRes
            }
            return contactRes
        }
    }

    async CreateContact(payload) {
        //it's a brand new contact with a brand new company, we can post everything through the company
        if (payload.organizationId && !validator.isUUID(payload.organizationId)) {
            const res = await this.httpClient.post("/organizations", {
                name: payload.organizationId,
                email: payload.email,
                persons: [payload],
                phoneNumbers: payload.phoneNumbers,
                address: payload.address
            })
            if (res instanceof Contact) {
                return res.getEmployees()[0]
            }
        }
        //create person without organization
        return this.httpClient.post("/persons", payload)
    }

    async UpdateContact(contactId: string, payload) {
        //we need to create an organization first so we can assign it
        if (payload.organizationId && !validator.isUUID(payload.organizationId)) {
            const organizationRes = await this.httpClient.post("/organizations", {
                name: payload.organizationId,
                email: payload.email,
                phoneNumbers: payload.phoneNumbers,
                address: payload.address
            })
            if (organizationRes instanceof Contact) {
                payload.organizationId = organizationRes.getId()
            }
        }
        return this.httpClient.patch(`/persons/${contactId}`, payload)
    }

    async DeleteContact(contactId: string) {
        return await this.httpClient.delete(`/contacts/${contactId}`)
    }

    async SaveSEPAIntent(contactId: string) {
        return await AppContext.getApiClient().post(`/contacts/${contactId}/setup-save-sepa-intent`)
    }

    async SaveSEPABankOnFile(contactId: string, payload) {
        return await AppContext.getApiClient().post(`/contacts/${contactId}/sepa-banks-on-file`, payload)
    }
}

const instance = new ContactService()
export default instance



// WEBPACK FOOTER //
// ./src/state/contact/services/ContactService.ts